/* Ortak kategori kutuları satırı: masaüstü ok düğmeleri + sığıyorsa ortalama.
   Kaynak: Line2026/Store-Tech/theme_live_pages/assets/line-live-tiles.js */
(function(){
  function init(){
    [].forEach.call(document.querySelectorAll('.bx-trow'),function(row){
      var sc=row.querySelector('.bx-tscroll'), l=row.querySelector('.bx-tarr.l'), r=row.querySelector('.bx-tarr.r'); if(!sc) return;
      function upd(){ var max=sc.scrollWidth-sc.clientWidth; sc.classList.toggle('is-fit',max<=2); if(l) l.hidden=sc.scrollLeft<=4; if(r) r.hidden=sc.scrollLeft>=max-4; }
      if(!row._bxTiles){
        row._bxTiles=upd;
        sc.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd);
        [l,r].forEach(function(b,i){ if(b) b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); sc.scrollBy({left:(i?1:-1)*sc.clientWidth*.8,behavior:'smooth'}); }); });
      }
      row._bxTiles();
    });
  }
  window.lineTilesInit=init;
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  window.addEventListener('load',init);
})();
